import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { colorSubText } from "../../../theme";

interface CombustivelFilterCardProps {
  combustiveis: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
}
export function CombustivelFilterCard({
  combustiveis,
  selected,
  onChange,
}: CombustivelFilterCardProps) {
  const handleToggle = (combustivel: string) => {
    if (selected.includes(combustivel)) {
      onChange(selected.filter((c) => c !== combustivel));
    } else {
      onChange([...selected, combustivel]);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        p: 2,
        borderRadius: 3,
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      {/* Título */}
      <Box mb={2}>
        <Typography
          fontWeight={700}
          fontSize="0.7rem"
          letterSpacing={1.5}
          textTransform="uppercase"
          color="text.secondary"
        >
          Tipo de Combustível
        </Typography>

        <Box
          sx={{
            width: 32,
            height: 4,
            bgcolor: "primary.main",
            mt: 0.5,
            borderRadius: 2,
          }}
        />
      </Box>

      {/* Opções */}
      <Box display="flex" flexDirection="column" gap={2}>
        {combustiveis.map((combustivel) => (
          <FormControlLabel
            key={combustivel}
            control={
              <Checkbox
                checked={selected.includes(combustivel)}
                onChange={() => handleToggle(combustivel)}
                color="primary"
              />
            }
            label={
              <Typography
                fontSize="0.85rem"
                fontWeight={600}
                color={colorSubText}
                sx={{
                  transition: "color 0.2s ease",
                }}
              >
                {combustivel}
              </Typography>
            }
            sx={{
              ml: 0,
              cursor: "pointer",
              "&:hover .MuiTypography-root": {
                color: "primary.main",
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
